<template>
    <div class="upload-box">
        <!-- 禁用 只展示文件列表 -->
        <ul v-if="disabled" class="file-list" style="margin-top: 0;">
            <li v-for="item in fileList" :key="item.uid">
                <i class="el-icon-document"></i>
                <span class="name" @click.stop="payFileDownload(item)">{{ item.name }}</span>
            </li>
        </ul>
        <!-- 允许编辑 -->
        <el-upload v-else action="" :http-request="uploadRequest" :file-list="fileList" multiple :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">单个文件大小不得超过50MB</div>
            <ul class="file-list">
                <li v-for="(item, index) in fileList" :key="item.uid">
                    <i class="el-icon-document"></i>
                    <span class="name" @click.stop="payFileDownload(item)">{{ item.name }}</span>
                    <i class="el-icon-close close" @click.stop="fileRemove(index)"></i>
                </li>
            </ul>
        </el-upload>
    </div>
</template>

<script>
import { uploadAttachment, downAttachment } from '@/api/requirement'

export default {
    name: 'uploadAtt',
    props: {
        value: Array,
        // 文件存到哪个文件夹：1-需求附件 | 2-会议附件
        bizType: {
            type: [String, Number],
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            handler(val) {
                this.fileList = this.$utils.deepCopy(val);
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            fileList: []
        }
    },
    methods: {
        // 抛出值
        fileChange() {
            this.$emit('input', this.fileList);
        },
        // 文件上传 
        uploadRequest({ file, onProgress, onSuccess, onError }) {
            // -----------大小限制-----------
            let size = file.size / 1024 / 1024;
            if (size > 50) {
                this.$MessageBox.MessageWarning("上传失败！文件大小不得超过50M");
                this.fileList = this.fileList.filter(f => f.uid !== file.uid);
                return false;
            }
            // -----------请求接口-----------
            const formData = new FormData();
            formData.append('file', file);
            uploadAttachment(formData, `?bizType=${this.bizType}`, (event) => {
                let percent = Math.round((event.loaded * 100) / event.total);
                onProgress({ percent });
            }).then(res => {
                onSuccess(res.data);
                this.fileList.push({
                    uid: file.uid,
                    name: file.name,
                    path: res.data.filePath,
                    id: res.data.id,
                });
                this.fileChange();
            }).catch(err => {
                onError(err);
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 移除文件
        fileRemove(index) {
            if (this.disabled) return;
            this.fileList.splice(index, 1);
            this.fileChange();
        },
        // 下载文件
        payFileDownload({ id }) {
            downAttachment({ fileId: id }).then(res => {
                // 处理blob
                if (res.data.type === "application/json") {
                    let blobReader = new Response(res.data).json();
                    blobReader.then((item) => {
                        this.$MessageBox.MessageWarning(item.msg);
                    });
                } else {
                    this.$utils.download(res);
                }
            }).catch(err => {
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.upload-box {
    position: relative;
    /deep/ .el-upload {
        width: 100%;
        text-align: left;
    }
    .el-upload__tip {
        position: absolute;
        left: 100px;
        top: 3px;
    }
}
.file-list {
    width: 100%;
    list-style: none;
    li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #606266;
        margin-top: 5px;
        padding-left: 5px;
        padding-right: 5px;
        line-height: 1.8;
        border-radius: 4px;
        cursor: pointer;
        .name {
            max-width: 400px;
            margin-left: 5px;
            margin-right: auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .close {
            cursor: pointer;
        }
        &:hover {
            color: #0540c3;
            background-color: #f5f7fa;
        }
    }
}
</style>